import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c7e4f35"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "header-menu_items flex"
}
const _hoisted_2 = { href: "/" }
const _hoisted_3 = {
  key: "expanded",
  class: "aside-main_sticky_logo-wrapper_mask_image",
  src: "https://dam.malt.com/navbar/malt-logo-red.svg?vh=9690b2",
  width: "100",
  height: "28",
  alt: "Malt logo"
}
const _hoisted_4 = { class: "header-menu_actions flex" }

import {useAsideMenu, useDisplayMode} from '@/logged/features/aside-menu';
    import {useHeaderMenu} from '@/logged/features/header-menu';
    import {storeToRefs} from 'pinia';
    import HeaderMenuItem from './HeaderMenuItem.vue';
    import {useDisplayMobile} from '@/logged/common/composables';
    import HeaderSearchWrapper from './HeaderSearchWrapper.vue';
    import {LogoWrapper} from '@/logged/common/ui';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderMenu',
  setup(__props) {

    const {isDisplayMobile} = useDisplayMobile();
    const asideMenuStore = useAsideMenu();
    const headerMenuStore = useHeaderMenu();
    const displayModeStore = useDisplayMode();

    const {isDisplayModeFunnel, isDisplayModeFull} = storeToRefs(displayModeStore);
    const {searchDisplayMode, headerNavigationTabs} = storeToRefs(headerMenuStore);

    function handleChangeNavBarDisplayMode() {
        if (isDisplayMobile.value) {
            asideMenuStore.toggleMobileNavBarOpened();
        } else {
            displayModeStore.toggleNavBarDisplayMode();
        }
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["header-menu flex", {isMobile: _unref(isDisplayMobile)}])
  }, [
    (_unref(isDisplayModeFunnel))
      ? (_openBlock(), _createBlock(_unref(LogoWrapper), { key: 0 }))
      : _createCommentVNode("", true),
    (!_unref(isDisplayModeFunnel))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(HeaderMenuItem, {
            title: _unref(isDisplayModeFull) ? 'Reduce the navigation bar' : 'Expand the navigation bar',
            icon: "header/burger",
            "can-be-active": false,
            size: 26,
            "show-title": false,
            onClick: handleChangeNavBarDisplayMode
          }, null, 8, ["title"]),
          _createElementVNode("a", _hoisted_2, [
            (_unref(isDisplayMobile))
              ? (_openBlock(), _createElementBlock("img", _hoisted_3))
              : _createCommentVNode("", true)
          ]),
          (_unref(searchDisplayMode) !== 'NONE' && !_unref(isDisplayMobile))
            ? (_openBlock(), _createBlock(HeaderSearchWrapper, { key: 0 }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(headerNavigationTabs), (menu) => {
              return (_openBlock(), _createBlock(HeaderMenuItem, {
                key: menu.id,
                tab: menu
              }, null, 8, ["tab"]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(searchDisplayMode) !== 'NONE' && _unref(isDisplayMobile))
      ? (_openBlock(), _createBlock(HeaderSearchWrapper, {
          key: 2,
          class: "isMobile"
        }))
      : _createCommentVNode("", true)
  ], 2))
}
}

})